import { ContentTagList } from '../ContentTagList/ContentTagList.component';
import { ActivityCode, InterestCode } from 'pleinchamp-api-client';
import React, { ComponentPropsWithRef, FC } from 'react';
import { SocialShareBar } from '@components/SocialShare/SocialShareBar.component';
import { Text } from '@components/Text/Text.component';
import { buildTagList } from '@utils/card';
import classnames from 'classnames';

type Props = ComponentPropsWithRef<'div'> & {
  signature?: string;
  activityCodes?: ActivityCode[];
  interestCodes?: InterestCode[];
  isTagsDarkGreenStyle?: boolean;
};

const ContentFooter: FC<Props> = ({
  isTagsDarkGreenStyle = false,
  signature,
  activityCodes,
  interestCodes,
  className,
  ...rest
}) => {
  const rootClass = classnames('content-footer flex column', className);
  const tags = buildTagList(activityCodes || [], interestCodes || []);

  return (
    <div className={rootClass} {...rest}>
      {signature && (
        <Text className="plc-mb-m" tag="div" variant="h4">
          {signature}
        </Text>
      )}
      {(activityCodes || interestCodes) && (
        <ContentTagList className="plc-mb-s" isDarkGreen={isTagsDarkGreenStyle} tags={tags} />
      )}
      <SocialShareBar withPrefix />
    </div>
  );
};

export { ContentFooter };
